import StyledLink from '@components/common/Link';
import { HeroWrapper, Highlight, HeroTitle, HeroData, DataItem } from './EarnHero.styles';
import CountUp from 'react-countup';
import EarnSVG from '@public/earn/earn.svg';
import { useLpAPY, useTvl } from '@components/store/getters';

export function EarnHero() {
  const formatNumberWithCommas = (value: Number) => {
    return value.toLocaleString();
  };
  const lpApy = useLpAPY();
  const tvl = useTvl();
  return (
    <>
      <HeroWrapper>
        <section>
          <HeroTitle type="h1">
            Earn <Highlight>passive income</Highlight> as a Liquidity Provider
          </HeroTitle>
          <p>Provide liquidity to our 3CRV/lvUSD Curve Pool, and receive ARCH and CRV as rewards.</p>
          <HeroData>
            <>
              <DataItem>
                <strong>
                  {!lpApy && '--'}
                  {lpApy && (
                    <>
                      <CountUp useEasing duration={2} end={lpApy} decimals={2} formattingFn={formatNumberWithCommas} />%
                    </>
                  )}
                </strong>
                <label>
                  <b>Live</b> Pool APY
                </label>
              </DataItem>
              <DataItem>
                <b>
                  {!tvl && '--'}
                  {tvl && (
                    <>
                      $
                      <CountUp useEasing duration={2} end={tvl} decimals={0} formattingFn={formatNumberWithCommas} />
                    </>
                  )}
                </b>
                <label>
                  <b>Live</b> Pool TVL
                </label>
              </DataItem>
            </>
          </HeroData>
          <p>
            <StyledLink
              target="_blank"
              href="https://curve.fi/#/ethereum/pools/factory-v2-268/deposit"
              variant="button"
            >
              Provide Liquidity on Curve
            </StyledLink>
          </p>
          <StyledLink
            target="_blank"
            href="https://dune.com/archimedesfi/liquidity-provider-dashboard"
            variant="outline"
          >
            Monitor Pool Analytics
          </StyledLink>
        </section>
        <EarnSVG />
      </HeroWrapper>
    </>
  );
}
